import clsx from 'clsx';

import { Button } from '@/components/button/button';
import Modal from '@/components/modal/modal';
import { Heading } from '@/components/typography/heading';


type VersionCreateModalProps = {
  onConfirm: () => void;
  onCancel: () => void;
};

export const VersionCreateModal = ( {
  onConfirm,
  onCancel
}: VersionCreateModalProps ) => (
  <Modal>
    <form
      onSubmit={ ( e ) => {
        e.preventDefault();
        onConfirm();
      } }
    >
      <Heading as="h2" size="md">
        Confirm
      </Heading>
      <div className={ clsx( 'layout__row', 'pad' ) }>
        <p>
          Are you sure you want to create a new version? All current unsaved
          changes will be included in the new version.
        </p>
      </div>
      <div className={ clsx( 'layout__row', 'pad', 'flex_right' ) }>
        <Button variant="secondary" size="sm" onClick={ onCancel }>
          No
        </Button>
        <Button variant="primary" size="sm" type="submit">
          Yes
        </Button>
      </div>
    </form>
  </Modal>
);
